import { RegionsEnum } from 'src/generated/operations';
import { Unit } from 'uom';
import { Units } from 'uom-units';
import { BtuPerPoundPerFahrenheit } from 'src/modules/user-input/calcV100/BtuPerPoundPerFahrenheit.ts';
import { Psi } from 'src/utils/Psi.ts';

export type AllowedUnits = {
    ratedCapacity: Unit.Unit<'Power'>[];
    temperatureDifference: Unit.Unit<'Temperature'>[];
    volumetricFlow: Unit.Unit<'VolumeFlow'>[];
    airflowVolume: Unit.Unit<'VolumeFlow'>[];
    massFlow: Unit.Unit<'MassFlow'>[];
    heatCapacity: Unit.Unit<'SpecificHeatCapacity'>[];
    density: Unit.Unit<'Density'>[];
    temperature: Unit.Unit<'Temperature'>[];
    dpmv: Unit.Unit<'Pressure'>[];
    inletOutlet: Unit.Unit<'Pressure'>[];
};

export function getAllowedUnits(region: RegionsEnum): AllowedUnits {
    if (region === RegionsEnum.Am) {
        return {
            ratedCapacity: [Units.BtuPerHour],
            temperatureDifference: [Units.Fahrenheit, Units.Kelvin],
            temperature: [Units.Fahrenheit],
            volumetricFlow: [Units.GallonsPerMinute],
            massFlow: [Units.PoundLbPerHour],
            heatCapacity: [BtuPerPoundPerFahrenheit],
            density: [Units.PoundPerCubicFoot],
            dpmv: [Psi, Units.KiloPascal, Units.Pascal],
            inletOutlet: [Psi],
            airflowVolume: [Units.CubicFeetPerMinute],
        };
    }

    return {
        ratedCapacity: [Units.KiloWatt],
        temperatureDifference: [Units.Celsius, Units.Kelvin],
        temperature: [Units.Celsius],
        volumetricFlow: [Units.CubicMeterPerHour, Units.LiterPerSecond, Units.LiterPerHour],
        massFlow: [Units.KilogramPerHour],
        heatCapacity: [Units.KilojoulePerKilogramKelvin],
        density: [Units.KilogramPerCubicMeter],
        dpmv: [Units.KiloPascal, Units.Bar],
        inletOutlet: [Units.Bar],
        airflowVolume: [Units.CubicMeterPerHour],
    };
}
